import { render } from "./NotificationView.vue?vue&type=template&id=0470069b&ts=true"
import script from "./NotificationView.vue?vue&type=script&lang=ts"
export * from "./NotificationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Notifications/NotificationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0470069b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0470069b', __exports__)) {
    api.reload('0470069b', __exports__)
  }
  
  module.hot.accept("./NotificationView.vue?vue&type=template&id=0470069b&ts=true", () => {
    api.rerender('0470069b', render)
  })

}


export default __exports__